__turbopack_context__.v({
  "cardsGrid": "CoreCards-module-scss-module__klRdzq__cardsGrid",
  "coreCards": "CoreCards-module-scss-module__klRdzq__coreCards",
  "emptyState": "CoreCards-module-scss-module__klRdzq__emptyState",
  "header": "CoreCards-module-scss-module__klRdzq__header",
  "title": "CoreCards-module-scss-module__klRdzq__title",
});
